// import clubApi from './dev'; // dev
import clubApi from './prod'; // prod

export default clubApi;
